import fp from 'lodash/fp';

// eslint-disable-next-line import/prefer-default-export
export const createImpactIdSummaryRows = (rows) => {
    const filteredRows = fp.filter(obj => obj.impactAnalysisId)(rows);
    return filteredRows.map(row => (
        {
            date: row.runDate,
            userName: row.userName,
            id: row.impactAnalysisId
        }
    ));
};
